@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3">
      <h3>Daysheet Resource Order</h3>
    </div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      Set the order your resources and resource groups appear in on the Daysheet, and choose which ones it shows.
      Drag a row by its handle, or use the arrows, then click Save.
    </p>
    <!-- The Itinerary report and view, and the Booking Calendar, read the same order and the same switches - see
    ItineraryService.fromDaysheetOrder. -->
    <div style="display:flex; gap:10px; align-items:flex-start; background:#fffbeb; border:1px solid #f59e0b; border-radius:6px; padding:12px 16px; margin-bottom:16px;">
      <span class="pi pi-exclamation-triangle" style="color:#d97706; margin-top:3px;"></span>
      <div style="color:#78350f; line-height:1.6;">
        <b>This also sets the Itinerary.</b> The resources and resource groups switched on here are the ones shown on the Itinerary report and the Itinerary view, in this order, and on the Booking Calendar.
        A resource group that is switched on shows every resource in it.
      </div>
    </div>
    <!-- Above the list, so it is seen as soon as anything is moved. -->
    @if (changed) {
      <div class="dro-unsaved">
        <span class="pi pi-exclamation-triangle"></span>
        <span><b>You have unsaved changes.</b> Click Save at the bottom of the page to keep the new order.</span>
      </div>
    }
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table [value]="rows" [reorderableRows]="true" (onRowReorder)="onRowReorder()" responsiveLayout="scroll">
        <ng-template #header>
          <tr>
            <th style="width: 3rem;"></th>
            <th style="width: 4rem;">Order</th>
            <th>Name</th>
            <th style="width: 10rem;">Type</th>
            <th style="width: 10rem; text-align: center;">Show on Daysheet</th>
            <th style="width: 7rem;"></th>
          </tr>
        </ng-template>
        <ng-template #body let-row let-index="rowIndex">
          <tr [pReorderableRow]="index" [class.dro-hidden]="!row.showondaysheet">
            <td><span class="pi pi-bars dro-handle" pReorderableRowHandle></span></td>
            <td>{{index + 1}}</td>
            <td>
              <span class="pi" [ngClass]="row.propertytype == 'RESOURCEGROUP' ? 'pi-sitemap' : 'pi-stop'" style="margin-right: 10px;"></span>{{row.name}}
            </td>
            <td>
              <span class="dro-type" [class.dro-type-group]="row.propertytype == 'RESOURCEGROUP'">
                {{row.propertytype == 'RESOURCEGROUP' ? 'Resource Group' : 'Resource'}}
              </span>
            </td>
            <td style="text-align: center;">
              <p-toggleswitch [(ngModel)]="row.showondaysheet" (onChange)="toggled()"></p-toggleswitch>
            </td>
            <td style="white-space: nowrap;">
              <button pButton type="button" class="p-button-sm p-button-text" [disabled]="index == 0" (click)="move(index, -1)" pTooltip="Move up" [iconOnly]="true"><span class="p-button-icon pi pi-arrow-up" aria-hidden="true"></span></button>
              <button pButton type="button" class="p-button-sm p-button-text" [disabled]="index == rows.length - 1" (click)="move(index, 1)" pTooltip="Move down" [iconOnly]="true"><span class="p-button-icon pi pi-arrow-down" aria-hidden="true"></span></button>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="6" style="text-align: center;">There are no resources or resource groups.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- Save at the foot of the page, left-aligned like the other edit pages. -->
    <div class="dro-actions">
      <button pButton type="button" class="p-button p-element p-ripple p-button-success p-component dro-save" (click)="save()">
        <span class="pi pi-save" style="margin-right:8px;"></span>
        <span>Save</span>
      </button>
    </div>
  </div>
}
